import { Enums } from '@bode-canada/core';
import ServerlessApiService from '@/services/api/serverless/ServerlessApiService';
import { NewListingSoldDto, NewListingLinkDto } from '@/types/new-listing-sold';

const { NewListingSoldApiPathEnum, ServerlessApiPathEnum } = Enums;

type GetSoldPropertiesTransactionsFilters = {
  minDate?: string;
  maxDate?: string;
  statuses?: Enums.ListingStatusEnum[];
};

export default class NewListingSoldApiService {
  static BASE_URL = `${NewListingSoldApiPathEnum.NEW_LISTINGS_SOLD}/${ServerlessApiPathEnum.V1}`;

  static getSoldTransactionsByAddressId(
    addressId: number,
    params?: GetSoldPropertiesTransactionsFilters,
  ): Promise<NewListingSoldDto[]> {
    return ServerlessApiService.get(
      `${this.BASE_URL}`,
      { params: { ...params, addressId } },
    );
  }

  static getActiveByAddressId(addressId: number): Promise<NewListingLinkDto> {
    return ServerlessApiService.get(
      `${this.BASE_URL}/${NewListingSoldApiPathEnum.ACTIVE_LINK}`,
      { params: { addressId } },
    );
  }
}
